<template lang="pug">
ods-module.loyalty-commerce-table
      div(slot="header")
        span {{ this.$t('loyalty.channel') }}
      filter-table(
         layout="text"
         @inputSearchFilter="inputSearchFilter")
      .credits-table.ods-mt-6
        ods-table(
          v-loading="loadingTable"
          style='width: 100%'
          size="medium"
          :data='tableDataRendered'
          )
          ods-table-column(prop='CODENTID' :label="this.$t('loyalty.code')")
            template(slot-scope="scope")
              div {{ scope.row.codcanal }}
          ods-table-column(prop='IDMENSAJE' :label="this.$t('loyalty.description')")
            template(slot-scope="scope")
              div {{ scope.row.descanal }}
          ods-table-column(prop='CANTPUNT' :label="this.$t('loyalty.chanelpercentage')")
            template(slot-scope="scope")
              div {{ scope.row.porcanal }} %
          ods-table-column(prop='CLIENTE' :label="this.$t('loyalty.emitterpercentage')")
            template(slot-scope="scope")
              div {{ scope.row.porbanco }} %
        div.footer
          paginator(
            :isNextPage="indMasDatos"
            :currentPage="currentPage"
            @buttonPrevAction="getPrevPage"
            @buttonNextAction="getNextPage")
</template>

<script>
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ComercioTable',
  components: {
    FilterTable,
    Paginator
  },
  props: {
    activarCanales: {
      required: true
    }
  },
  data () {
    return {
      loadingTable: true,
      tableDataRendered: null,
      tableData: null,
      currentPage: null,
      indMasDatos: null,
      paginationParams: null,
      activePagination: false
    }
  },
  computed: {
    ...mapGetters({
      loadingProgram: 'getProgramState'
    })
  },
  methods: {
    ...mapActions(['getCanales']),
    async getData (params) {
      this.loadingTable = true
      const response = await this.getCanales(params)
      if (response.registros && response.retorno !== 210) {
        this.tableData = Array.isArray(response.registros) ? response.registros : [response.registros]
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      } else {
        this.tableData = null
        this.tableDataRendered = this.tableData
        this.loadingTable = false
      }
      this.currentPage = response.pantPagina
      this.indMasDatos = response.indMasDatos
      this.paginationParams = {
        claveInicio: response.claveInicio,
        claveFin: response.claveFin
      }
    },
    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter(obj => Object.values(obj).some(val => val.toString().toLowerCase().indexOf(text.toLowerCase()) > -1))
    },
    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.activePagination = true
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.activePagination = true
      this.getData(params)
    }
  },
  watch: {
    async activarCanales (newVal, oldVal) {
      if (newVal) {
        await this.getData()
      }
    },
    async loadingProgram (data, oldData) {
      if (data && this.activarCanales) {
        await this.getData()
      } else {
        if (data && this.activePagination) {
          await this.getData()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.loyalty-commerce-table{
.notfound {
  margin-top: rem(28)
}

&__subtitle{
  display: flex;
  padding: 32px 0 0 24px;
  font-size: 16px;
  font-weight: 400;
  justify-content: center;
}
  .ods-table {
    background: #fff;
    margin: 12px 0;
  }
}
</style>
